import Vue from "vue";
import VueResource from "vue-resource";

import store from "@/store";

import { overrideApiCall } from "@/helpers";
import { IFakeCall } from "@/models/object";

Vue.use(VueResource);

/**
 * Intercepteur sur les appels AJAX pour ajouter le token
 * et simmuler les appels aux API en mode development
 *
 * @param {any} request : l'objet sur l'appel à faire
 * @param {any} next : la prochaine actions sur l'appel
 */
const auth: string = "auth";
Vue.http.interceptors.push((request: any, next: any) => {
  // Ajoute le token pour Veos
  request.headers.set("Authorization", "Bearer " + store.state[auth].token);
  // Bypass sur les appels en API en mode dev
  if (process.env.NODE_ENV === "development") {
    const fakeObj: IFakeCall | undefined = overrideApiCall(request);
    if (fakeObj) {
      return request.respondWith(fakeObj.body, {
        status: fakeObj.status,
      });
    }
  }
  next();
});
